import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getFacturas() {
  let url = `${webservice}/getFacturas?usuarioOK=''`;

  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
